"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NotificationsContainer: function() {
        return _Notifications.default;
    },
    useNotifications: function() {
        return _useNotifications.useNotifications;
    }
});
const _Notifications = /*#__PURE__*/ _interop_require_default(require("./Notifications"));
const _useNotifications = require("./useNotifications");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

//# sourceMappingURL=index.js.map